import {find, get, isUndefined, omit} from 'lodash';

import {KEYWORD_PROP_CONTENT_VALUE} from './auto_layout_screen_data_helpers';

export const SCREEN_BANNER_CONFIG = 'screenBanner';

const SCREEN_BANNER_MAPPINGS = 'mappings';

const MAPPING_DEFINITION_VALUE_MAPPING = 'valueMapping';
const MAPPING_DEFINITION_CONTENT_OBJECT = 'contentObject';
const MAPPING_DEFINITION_CONTENT_PROPERTY = 'contentProperty';

const MAPPED_VALUE_VALUE = 'value';

export class AutoLayoutMappedValue {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getRawData() {
    return this.rawData;
  }

  getValue() {
    return this.rawData[MAPPED_VALUE_VALUE];
  }

  getConfiguration() {
    return omit(this.rawData, [MAPPED_VALUE_VALUE]);
  }
}

export class AutoLayoutMappingDefinition {
  static initValueMapping(rawValueMapping) {
    const valueMapping = [];
    if (rawValueMapping) {
      rawValueMapping.forEach((mappedValue) => {
        valueMapping.push(new AutoLayoutMappedValue(mappedValue));
      });
    }
    return valueMapping;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.valueMapping = AutoLayoutMappingDefinition.initValueMapping(
      this.rawData[MAPPING_DEFINITION_VALUE_MAPPING]
    );
  }

  getRawData() {
    return this.rawData;
  }

  getValueMapping() {
    return this.valueMapping;
  }

  getContentObject() {
    return this.rawData[MAPPING_DEFINITION_CONTENT_OBJECT];
  }

  getContentProperty() {
    return this.rawData[MAPPING_DEFINITION_CONTENT_PROPERTY];
  }

  getConfigurationByData(data) {
    let foundMappedProperty;
    if (data) {
      const mappedPropertyObject = get(data, this.getContentProperty());
      if (mappedPropertyObject) {
        const value =
          mappedPropertyObject[KEYWORD_PROP_CONTENT_VALUE] ||
          mappedPropertyObject;
        const mappedPropertyValue = isUndefined(value.id) ? value : value.id;
        foundMappedProperty = find(
          this.getValueMapping(),
          (mappedProperty) => mappedProperty.getValue() === mappedPropertyValue
        );
      }
    }
    return foundMappedProperty
      ? foundMappedProperty.getConfiguration()
      : undefined;
  }
}

export class ScreenBannerConfig {
  static initMappings(rawMappings) {
    const mappings = [];
    if (rawMappings) {
      rawMappings.forEach((mapping) => {
        mappings.push(new AutoLayoutMappingDefinition(mapping));
      });
    }
    return mappings;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.mappings = ScreenBannerConfig.initMappings(
      this.rawData[SCREEN_BANNER_MAPPINGS]
    );
  }

  getRawData() {
    return this.rawData;
  }

  getMappings() {
    return this.mappings;
  }

  getConfigurationByData(data) {
    let configuration = {};
    this.getMappings().forEach(
      /** @param mapping {AutoLayoutMappingDefinition} */ (mapping) => {
        configuration = {
          ...configuration,
          ...mapping.getConfigurationByData(data),
        };
      }
    );
    return configuration;
  }
}

export default {
  ScreenBannerConfig,
  AutoLayoutMappingDefinition,
  AutoLayoutMappedValue,
};
